import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useAppSelector } from '../../reducers';
import { billingNameKeySelector } from '../../selectors/ProductsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
// TODO gross prop
const BillingNameTitle = ({
  skuId,
  billingNameKey
}) => {
  const billingName = useAppSelector(state => {
    if (billingNameKey !== undefined) return billingNameKey;
    return billingNameKeySelector(state, {
      skuId
    });
  });
  if (!isValidI18nKey(`pricing-pages-ui.productNamesV2.${billingName}.title`)) return null;
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `pricing-pages-ui.productNamesV2.${billingName}.title`
  });
};
export default BillingNameTitle;